const frontPageId = 'frontpage';

export { frontPageId };
